<ckeditor
  class="overflow-hidden"
  [editor]="editor"
  [config]="editorConfig"
  [formControl]="formControl"
  (ready)="editorCreated($event)"
></ckeditor>
